import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  SupportAccessGrant,
  SupportAccessGrantListResponse,
  SupportAccessRequestCreateRequest,
  SupportAccessSessionStartResponse,
} from '@chiroup/core/types/SupportAccess.type';

const supportAccessService = () => {
  const listGrants = async (clinicId: number): Promise<SupportAccessGrantListResponse> => {
    return ChiroUpAPI.get('api', `/clinic/${clinicId}/support-access/grants`, {});
  };

  const startSession = async (
    clinicId: number,
    grantId: string
  ): Promise<SupportAccessSessionStartResponse> => {
    return ChiroUpAPI.post('api', `/clinic/${clinicId}/support-access/grants/${grantId}/sessions`, {
      body: {},
    });
  };

  const requestAccess = async (
    clinicId: number,
    body: SupportAccessRequestCreateRequest
  ): Promise<SupportAccessGrant> => {
    return ChiroUpAPI.post('api', `/clinic/${clinicId}/support-access/requests`, { body });
  };

  return {
    listGrants,
    startSession,
    requestAccess,
  };
};

export default supportAccessService();
